module.exports = __webpack_public_path__ + "img/stop.19f9b637.svg";